import { onReady } from './util/onReady';

const io_options: IntersectionObserverInit = {
    rootMargin: '0px 0px -100% 0px',
    threshold: 0,
};

const io_callback: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry) => {
        entry.target.classList.toggle('sticking', entry.isIntersecting);
    });
};

function init() {
    const stickyImages = document.querySelectorAll('.parallax-sticky-element');

    if (stickyImages.length > 0) {
        const io_observer = new IntersectionObserver(io_callback, io_options);

        stickyImages.forEach((element) => {
            io_observer.observe(element);
        });
    }
}

onReady(() => {
    init();
});
